import { groupBy, min, max } from '@antv/util';
import pdf from 'pdfast';
import { quantile } from '../../utils/transform/quantile';
import { ViolinOptions } from './types';

export type ViolinData = {
  /** Xè½´ */
  x: string;

  /** å°æç´è½®å»ç size ééæ°æ® */
  violinSize: number[];
  /** å°æç´è½®å»ç y ééæ°æ® */
  violinY: number[];

  // ç®±çº¿å¾åºç¡æ°æ®
  /** æå¤§å¼ */
  high: number;
  /** æå°å¼ */
  low: number;
  /** ä¸ååä½æ° */
  q1: number;
  /** ä¸ååä½æ° */
  q3: number;
  /** ç®±çº¿å¾ä¸­çä¸­ä½å¼ */
  median: number[];

  /** ç®±çº¿å¾ä¸­çä¸çº¿è¾¹ç¼çº¿ */
  minMax: number[];
  /** ç®±çº¿å¾ä¸­çä¸ä¸ååä½ç¹ */
  quantile: number[];
};

export type PdfOptions = {
  min: number;
  max: number;
  size: number;
  width: number;
};

export const toBoxValue = (values: number[]) => {
  return {
    low: min(values),
    high: max(values),
    q1: quantile(values, 0.25),
    q3: quantile(values, 0.75),
    median: quantile(values, [0.5]),
    minMax: [min(values), max(values)],
    quantile: [quantile(values, 0.25), quantile(values, 0.75)],
  };
};

export const toViolinValue = (values: number[], pdfOptions: PdfOptions) => {
  const pdfResults: Array<{ x: number; y: number }> = pdf.create(values, pdfOptions);
  return {
    violinSize: pdfResults.map((result) => result.y),
    violinY: pdfResults.map((result) => result.x),
  };
};

export const transformViolinData = (options: ViolinOptions): ViolinData[] => {
  const { xField, yField, seriesField, data, kde } = options;

  /** çææ¦çå¯åº¦å½æ°çéç½® */
  const pdfOptions: PdfOptions = {
    min: kde.min,
    max: kde.max,
    size: kde.sampleSize,
    width: kde.width,
  };

  // æ æå
  if (!seriesField) {
    const group = groupBy(data, xField);
    return Object.keys(group).map((x) => {
      const records = group[x];
      const values = records.map((record) => record[yField]);
      return {
        x,
        ...toViolinValue(values, pdfOptions),
        ...toBoxValue(values),
      };
    });
  }

  // ææå
  const resultList: ViolinData[] = [];
  const seriesGroup = groupBy(data, seriesField);
  Object.keys(seriesGroup).forEach((series) => {
    const group = groupBy(seriesGroup[series], xField);
    return Object.keys(group).forEach((key) => {
      const records = group[key];
      const values = records.map((record) => record[yField]);
      resultList.push({
        x: key,
        [seriesField]: series,
        ...toViolinValue(values, pdfOptions),
        ...toBoxValue(values),
      });
    });
  });
  return resultList;
};
